<script lang="ts">
    import { _ } from "svelte-i18n"
    import { getDefaultLasersheetEngraving, lasersheetEngraving, resetLasersheetEngraving } from "../../../../../store"
    import {
        initializeMultilineLasersheet,
        LasersheetTypes,
        readLasersheetEngravingFromLocalStorage,
    } from "./../helper"
    import FormInputText from "../../../../widgets/Form/FormInputText.svelte"
    import FontSelect from "../../../../widgets/Form/FontSelect.svelte"
    import Icon from "../../../../widgets/Icon.svelte"
    import { mdiFormatAlignCenter, mdiFormatAlignJustify } from "@mdi/js"
    import { onMount } from "svelte"
    interface Props {
        product: Product
        setActiveImage: (idx: number) => void
    }

    let { product, setActiveImage }: Props = $props()

    let multiline = $state(initializeMultilineLasersheet($lasersheetEngraving)),
        houseNr = $state(""),
        street = $state(""),
        nameShield = $state(""),
        footerShield = $state("")

    const activeLasersheets = product.lasersheet_configurator.map((s) => s.lasersheet_nr)
    function setVariables() {
        if (!$lasersheetEngraving._customized) return
        multiline = initializeMultilineLasersheet($lasersheetEngraving)
        houseNr = $lasersheetEngraving.sheet1_houseNr
        street = $lasersheetEngraving.sheet1_street
        nameShield = $lasersheetEngraving.sheet2_line1
        footerShield = $lasersheetEngraving.sheet3_line1
    }
    if (readLasersheetEngravingFromLocalStorage(activeLasersheets)) {
        $lasersheetEngraving._customized = true
        setVariables()
    }

    onMount(() => {
        setVariables()
        if (activeLasersheets.includes(LasersheetTypes.FooterShield)) {
            $lasersheetEngraving.sheet3_line1 = "Zeitung"
        }
    })
    const mailboxHasNoEngravingInput = () => !multiline && !houseNr && !street && !nameShield
    function onModification() {
        if (!$lasersheetEngraving._customized) setActiveImage(0)
        if (!$lasersheetEngraving._customized) resetLasersheetEngraving()

        $lasersheetEngraving._customized = true
        setTimeout(() => {
            if (mailboxHasNoEngravingInput()) $lasersheetEngraving = getDefaultLasersheetEngraving()
        }, 10)
    }

    function multilineChange(e: Event) {
        const lines = multiline.split("\n")
        if ("key" in e && e.key === "Enter") {
            if (lines.length > 3) multiline = lines.slice(0, 3).join("\n")
        }
        onModification()
        $lasersheetEngraving.sheet1_line1 = lines[0]
        $lasersheetEngraving.sheet1_line2 = lines[1]
        $lasersheetEngraving.sheet1_line3 = lines[2]
    }

    function houseNrChange() {
        onModification()
        $lasersheetEngraving.sheet1_houseNr = houseNr
    }

    function streetChange() {
        onModification()
        $lasersheetEngraving.sheet1_street = street
    }
    function nameShieldChange() {
        onModification()
        $lasersheetEngraving.sheet2_line1 = nameShield
    }

    function footerShieldChange() {
        onModification()
        $lasersheetEngraving.sheet3_line1 = footerShield
    }
</script>

{#if activeLasersheets.length > 0}
    <form class="lasersheet-input">
        {#if activeLasersheets.includes(LasersheetTypes.NameShield)}
            <span>
                {$_("product.name-shield")}
            </span>
            <section>
                <div>
                    <FormInputText
                        name="name-shield-line1"
                        label={$_("product.name")}
                        maxlength={35}
                        bind:value={nameShield}
                        onKeyUp={nameShieldChange}
                    />
                </div>
            </section>
        {/if}
        {#if activeLasersheets.includes(LasersheetTypes.MainShield)}
            <section class="seperator"></section>
            {#if activeLasersheets.length > 1}
                <span>
                    {$_("product.main-shield")}
                </span>
            {/if}
            <section>
                <div class="switch">
                    <button
                        class={$lasersheetEngraving.sheet1_layout == 1 ? "active" : ""}
                        onclick={(e) => {
                            e.preventDefault()
                            $lasersheetEngraving.sheet1_layout = 1
                        }}
                    >
                        <Icon path={mdiFormatAlignJustify} size={"24px"} />
                        {$_("product.justification")}
                    </button>
                    <button
                        class={$lasersheetEngraving.sheet1_layout == 1 ? "" : "active"}
                        onclick={(e) => {
                            e.preventDefault()
                            $lasersheetEngraving.sheet1_layout = 2
                        }}
                    >
                        <Icon path={mdiFormatAlignCenter} size={"24px"} />
                        {$_("product.centered")}
                    </button>
                </div>
            </section>

            <section>
                <div>
                    <FormInputText
                        type="textarea"
                        bind:value={multiline}
                        name="multiline-name"
                        label={$_("product.3-row-name")}
                        style="resize: none; height: 100px"
                        onKeyUp={multilineChange}
                        maxlength={52}
                    ></FormInputText>
                </div>
            </section>
            <section>
                <div>
                    <FormInputText
                        name="house-number"
                        label={$_("product.housenumber")}
                        bind:value={houseNr}
                        onKeyUp={houseNrChange}
                        maxlength={5}
                    />
                </div>
                <div>
                    <FormInputText
                        name="street"
                        label={$_("product.street")}
                        bind:value={street}
                        maxlength={50}
                        onKeyUp={streetChange}
                    />
                </div>
            </section>
        {/if}
        {#if activeLasersheets.includes(LasersheetTypes.FooterShield)}
            <section class="seperator"></section>
            <span>
                {$_("product.newspaper-shield")}
            </span>
            <section>
                <div class="fixed-text-info">
                    {$_("product.newspaper-fixed-text")}
                </div>
            </section>
        {/if}
        <section class="seperator"></section>
        <span>
            {$_("product.font")}
        </span>
        <section>
            <div>
                <FontSelect bind:value={$lasersheetEngraving.font} />
            </div>
        </section>
        {$_("product.only_estimated_visual")}
    </form>
{/if}

<style lang="less">
    @import "../../../../../css/variables.less";
    .lasersheet-input {
        display: flex;
        flex-direction: column;
        gap: 10px;
        width: 100%;
        border-radius: 4px;
        background: var(--grey-100);
        padding: 1.2rem;
        margin-bottom: 0.6rem;
        @media @max-mobile-product {
            background-color: transparent;
            padding: 0px;
        }
        section {
            width: 100%;
            display: flex;
            gap: 10px;

            & > div {
                flex: 1;
            }
            .switch {
                display: flex;
                gap: 0.6rem;
                button {
                    border: none;
                    display: flex;
                    align-items: center;
                    gap: 0.3rem;
                    font-size: 1rem;
                    border-bottom: 1px solid var(--red-100);
                    color: var(--on-surface);
                    background-color: transparent;
                    opacity: 0.4;
                    cursor: pointer;
                    padding: 0.6rem 1.2rem;
                    transition: all 0.3s;
                    &:hover {
                        opacity: 0.8;
                    }
                    &.active {
                        opacity: 1;
                    }
                }
            }
            .fixed-text-info {
                padding: 0.6rem 1.2rem;
                background: var(--grey-200);
                border-radius: 4px;
                font-style: italic;
                color: var(--on-surface);
            }
        }
    }
</style>
